import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';

class AnnualkWhInput extends Component {
    handleAnnualKWHChange(value) {
        const { setUtilityAnnualKWH } = this.props;
        setUtilityAnnualKWH(Number(value));
    }

    render() {
        const { isLocked, annualKWH } = this.props;

        return (
            <div>
                <TextField
                    className="TextFields"
                    floatingLabelText="Annual Consumption (kWh)"
                    hintText="600,000"
                    onChange={(e, value) => this.handleAnnualKWHChange(value)}
                    disabled={isLocked}
                    defaultValue={annualKWH}
                />
            </div>
        );
    }
}
AnnualkWhInput.propTypes = {
    annualKWH: PropTypes.number,
    isLocked: PropTypes.bool.isRequired,
    setUtilityAnnualKWH: PropTypes.func.isRequired,
};

AnnualkWhInput.defaultProps = {
    annualKWH: 0,
};

export default AnnualkWhInput;



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/AnnualkWhInput/AnnualkWhInput.js